import Image from "next/image";
import React, { useRef } from "react";
import { Icon } from "../../icons/icons";
import Local from "../ImageLoader";
import PaymentItem from "./PaymentCustomer/PaymentItem";
import PaymentTextarea from "./PaymentCustomer/PaymentTextarea";
import SinglePaymentPage from "./SinglePaymentPage";
import { useTranslation } from "../../context/TranslationContext";

const Installment = () => {
  const { installPre, installMid, installNote, installUpTo, installTursab } =
    useTranslation();
  return (
    <>
      <div className="container">
        <div className="flex lg:flex-nowrap flex-wrap items-center justify-center my-10">
          <div className="lg:w-1/2 w-full flex lg:items-start items-center lg:justify-start justify-center">
            <div className=" w-[41.563rem] sm:h-[400px] h-[12.5rem] relative">
              <Image
                src={"/images/iade-image.png"}
                objectFit={"contain"}
                layout={"fill"}
                alt={""}
              />
            </div>
          </div>
          <div className="flex flex-col mb-8 lg:w-1/2">
            <div className="mb-8 flex flex-col">
              <span className="text-[20px] font-bold">
                <span className="text-primary">
                  {installPre}
                </span>{" "}
                {installMid.replace("{site}", process.env.NEXT_PUBLIC_SITENAME)}
              </span>
              <span className="text-[14px] font-medium text-black">
                {installNote}
              </span>
            </div>
            <div className="flex flex-col justify-center items-center">
              <div className="flex items-center">
                <div className="relative w-[400px] h-[20px] mb-6">
                  <Image
                    src={"/images/payments.svg"}
                    objectFit={"contain"}
                    layout={"fill"}
                    alt={""}
                    loader={Local}
                  />
                </div>
              </div>
              <span className="text-15 font-bold text-primary mb-3">
                {installUpTo}
              </span>
              <span className="text-[14px] font-extrabold text-black  text-center">
                {installTursab.replace("{site}", process.env.NEXT_PUBLIC_SITENAME)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Installment;
